/* Zestpics cart drawer: one-tap add-ons (Sep 2026). The drawer content itself is re-rendered by the theme after
   every cart change, so this script only handles clicks (event delegation) and opens the drawer after an add-on
   is added from the product page. */
(function () {
  'use strict';
  if (window.__zpDrawer) return; window.__zpDrawer = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
  }

  function add(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'zp-drawer', data: { source: 'zp-drawer', itemCount: cart.item_count } } }));
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zp-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true; b.textContent = 'Adding…';
    add(b.getAttribute('data-zp-add')).then(function () {
      b.textContent = '✓ Added'; b.classList.add('is-added');
    }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });

  /* Add-ons added from the product page box open the drawer so the shopper sees the offer progress */
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (d.source === 'zp-upsell') setTimeout(openDrawer, 150);
  });
})();
